import { fetchContentApi } from '../../services/content-api'

export const fetchGuidesApi = async (
  currentPhoneId,
  preSaleFlag,
  language,
  customer
) => {
  const preSaleURL = preSaleFlag ? '&presales=1' : ''
  return fetchContentApi(
    `/guides?language=${language}&phoneId=${currentPhoneId}` +
      `&customer=${customer}${preSaleURL}`
  )
}



// WEBPACK FOOTER //
// ./src/containers/Guides/services.js